import script from "./EmptyMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmptyMessage.vue?vue&type=script&lang=ts&setup=true"

import "./EmptyMessage.vue?vue&type=style&index=0&id=b1684a18&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1684a18"]])

export default __exports__